export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <span className="text-2xl font-heading text-primary-400 mb-3 block">爱漫画</span>
            <p className="text-sm text-foreground-300 leading-relaxed">
              非常爱漫画 — 免费漫画在线阅读平台。海量国漫、日漫、韩漫资源，下拉式畅读体验，每日同步更新。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">首页</a>
              <a href="#index" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">专题合集</a>
              <a href="#ranking" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">热门榜单</a>
              <a href="#faq" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-300 cursor-pointer hover:text-primary-400 transition-colors">热血战斗</span>
              <span className="text-sm text-foreground-300 cursor-pointer hover:text-primary-400 transition-colors">恋爱甜宠</span>
              <span className="text-sm text-foreground-300 cursor-pointer hover:text-primary-400 transition-colors">悬疑推理</span>
              <span className="text-sm text-foreground-300 cursor-pointer hover:text-primary-400 transition-colors">搞笑日常</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              更多合作伙伴即将加入，敬请期待。
            </p>
            <div className="mt-4">
              <h4 className="text-sm font-semibold text-background-50 mb-2">联系我们</h4>
              <div className="flex flex-col gap-1.5">
                <span className="text-sm text-foreground-300">submit@aimanhua.com</span>
                <span className="text-xs text-foreground-400">7×24小时在线</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2024 爱漫画 · 非常爱漫画免费在线看全集 · 好看的漫画大全
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
            <a href="#faq" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a>
          </div>
        </div>
      </div>
    </footer>
  );
}